import { render, staticRenderFns } from "./TheHeaderSearchLookup.vue?vue&type=template&id=d4896f12&"
import script from "./TheHeaderSearchLookup.vue?vue&type=script&lang=ts&"
export * from "./TheHeaderSearchLookup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports